export { isChinaRegion } from '../constant';
import { getEnv } from '../constant';

const getWenxiaobaiBaseUrl = () => {
  if (process.env.WENXIAOBAI_BASE_URL) {
    return process.env.WENXIAOBAI_BASE_URL;
  }
  if (getEnv() === 'dev') {
    return 'https://muset-web-dev.wenxiaobai.com';
  }
  return 'https://www.wenxiaobai.com';
};

export const WENXIAOBAI_BASE_URL = getWenxiaobaiBaseUrl();
export const WENXIAOBAI_PAYMENT_URL = `${WENXIAOBAI_BASE_URL}/chat/payment`;
export const WENXIAOBAI_CREDIT_URL = `${WENXIAOBAI_BASE_URL}/chat/payment/credit`;
export const WENXIAOBAI_SUBSCRIBER_URL = `${WENXIAOBAI_BASE_URL}/assets/subscriber`;
